var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"_relative"},[_c('section',{staticClass:"top _mb-4"},[_c('Navigation')],1),(_vm.sortedProjects && _vm.sortedProjects.length)?_c('ChartProjects',{attrs:{"projects":_vm.sortedProjects}}):_c('div',[_c('Preloader')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }